import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`
let baseUrl91 = `${httpUrl.host}/gy-apartment`
let baseUrl84 = `${httpUrl.host}/gy-apartment`

let api = {
  // 获取园区信息
  getYqInfo: `${baseUrl85}/yqInfo/getYqInfo`,

  // 声光报警设备分页
  getAlarmSoundLightDevicePage: `${baseUrl}/alarmSoundLightDevice/getPage`,

  // 添加声光报警设备
  addAlarmSoundLightDevice: `${baseUrl}/alarmSoundLightDevice/add`,

  // 修改声光报警设备
  updateAlarmSoundLightDevice: `${baseUrl}/alarmSoundLightDevice/update`,

  // 获取声光报警设备
  getAlarmSoundLightDeviceByCode: `${baseUrl}/alarmSoundLightDevice/getByCode`,

  // 删除声光报警设备
  deleteAlarmSoundLightDeviceByCodes: `${baseUrl}/alarmSoundLightDevice/deleteByCodes`,

  // 接警人分页
  getAlarmHandleManPage: `${baseUrl}/alarmHandleMan/getPage`,

  // 接警人列表
  getAlarmHandleManList: `${baseUrl}/alarmHandleMan/getList`,

  // 添加接警人
  addAlarmHandleMan: `${baseUrl}/alarmHandleMan/add`,

  // 查询接警人
  getAlarmHandleManByCode: `${baseUrl}/alarmHandleMan/getByCode`,

  // 修改接警人
  updateAlarmHandleMan: `${baseUrl}/alarmHandleMan/update`,

  // 删除接警人
  deleteAlarmHandleManByCodes: `${baseUrl}/alarmHandleMan/deleteByCodes`,

  // 人员列表
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 报警联动分页
  getLinkagePage: `${baseUrl}/linkage/getPage`,

  // 查询报警联动详情
  getLinkageByCode: `${baseUrl}/linkage/getByCode`,

  // 添加报警联动
  addLinkage: `${baseUrl}/linkage/add`,

  // 修改报警联动
  updateLinkage: `${baseUrl}/linkage/update`,

  // 删除报警联动
  deleteLinkageByCodes: `${baseUrl}/linkage/deleteByCodes`,

  // 查询报警联动
  getSourceByCode: `${baseUrl}/source/getByCode`,

  // 查询报警联动配置
  getSourceList: `${baseUrl}/source/getList`,

  // 报警联动
  addOrUpdate: `${baseUrl}/source/addOrUpdate`,

  // 获取消防设备列表
  getFcsDeviceList: `${baseUrl}/source/getFcsDeviceList`,

  // 获取视频设备列表
  getVideoDeviceList: `${baseUrl91}/videoDevice/getList`,

  // 获取视频设备通道列表
  getVideoPassagewayList: `${baseUrl}/source/getVideoDeviceList`,

  // 获取门禁设备列表
  getAccessDeviceList: `${baseUrl84}/accessDevice/getList`,

  // 报警记录
  getAlarmOpenRecordPage: `${baseUrl}/alarmOpenRecord/getPage`,

  // 接警记录
  getAlarmCloseRecordPage: `${baseUrl}/alarmCloseRecord/getPage`,

  // 报警联动改版 ————————————————————————————————————————————————————————————————————————
  // 报警联动分页
  getAlarmActionPage: `${baseUrl}/alarmAction/getPage`,

  // 修改报警联动配置
  setConfigAlarmAction: `${baseUrl}/alarmAction/setConfig`,

  // 查询报警联动配置
  getConfigAlarmAction: `${baseUrl}/alarmAction/getConfig`,

  // 大屏配置 ————————————————————————————————————————————————————————————————————————
  // 获取设备总量
  getDeviceStatistics: `${baseUrl}/overView/getDeviceStatistics`,

  // 获取当日报警数 未消警数
  getAlarmStatistics: `${baseUrl}/overView/getAlarmStatistics`,

  // 获取月报警排行
  getMonthAlarmRankList: `${baseUrl}/overView/getMonthAlarmRankList`,

  // 获取接警人列表
  getOverViewAlarmHandleManList: `${baseUrl}/overView/getAlarmHandleManList`,

  // 预览
  preview: `${baseUrl91}/videoDevice/preview`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Alarm.js